import has from 'lodash/has';
import isNil from 'lodash/isNil';
import { isReadOnly } from 'js/lib/ACLUtils';
import { useSelector } from 'react-redux';
import { useCurrentUser } from 'new/hooks/adapters/useCurrentUser';
import { useMemo } from 'react';
import { RESOURCE_TYPE_FLOW } from 'js/constants/resourceTypes';

export function useResourceAclItems(data, type) {
  const {
    entities: { orgs, users, teams },
    acl: { byKey },
    orgs: { orgMembers },
  } = useSelector((state: any) => state);

  const user = useCurrentUser();

  return useMemo(() => {
    if (!data || !type) {
      return { aclItems: [], readOnly: false };
    }

    const owner = users?.[data?.owner];

    let aclItems = [];

    const keyId = type === RESOURCE_TYPE_FLOW ? data.flow_node_id : data.id;

    if (byKey[`${type}${keyId}`]) {
      aclItems = byKey[`${type}${keyId}`];
    }

    const userOrg = orgs[user.org.id];

    const orgMembership =
      userOrg && has(userOrg, 'id') && !isNil(orgMembers[userOrg.id])
        ? orgMembers[userOrg.id]
        : null;

    return {
      owner: {
        type: 'USER',
        access_roles: ['owner'],
        org: orgs[owner?.default_org],
        ...owner,
      },
      aclItems: aclItems.map((aclItem) => {
        const item = {
          ...aclItem,
          ...(() => {
            if (aclItem.type === 'TEAM') {
              return teams[aclItem.id];
            }
            if (aclItem.type === 'ORG') {
              return orgs[aclItem.id];
            }
            if (aclItem.type === 'USER') {
              return orgMembership?.membersById?.[aclItem.id];
            }
            return {};
          })(),
          org: orgs[aclItem.accessor_org_id],
        };
        item.members = (() => {
          if (aclItem.type === 'ORG') {
            return Object.values(orgMembers[aclItem.id]?.membersById || {});
          }
          if (aclItem.type === 'TEAM') {
            return item.members?.map?.((member) => users[member.id] || member);
          }
          return undefined;
        })();
        return item;
      }),
      readOnly: (data && isReadOnly(data)) || false,
    };
  }, [orgs, byKey, orgMembers, user, data, type, users]);
}
